module.exports = "/pages/business/foodstadium/success-story-bg-1.png";